<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/customer-service-group">Create Customer Service
                Group</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">View List of Customer Service Groups</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Customer Service Groups</h2>
    </div>

    <div
        class="search_bar border-top border-bottom border-light mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mb-4 mb-md-5">
        <form class="search_form">
            <svg-icon src="../../../assets/images/icons/search.svg"></svg-icon>
            <input type="text" name="searchText" id="searchText" class="search_field"
                placeholder="Search by Customer Service Groups" [(ngModel)]="searchText"
                (keyup)="searchByText(searchText)" (search)="searchByText(searchText)" #searchcontact="ngModel">
            <button type="submit" class="d-none"></button>
        </form>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}}
            Customer Service Group{{totalRows > 1 ? 's' : null}}</h3>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let item of newMainGroups | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page, totalItems:newMainGroups?.length }; let i=index ">
            <div class="bg-lighter px-3 py-3 py-lg-4 rounded d-flex align-items-center column-gap-2 cursor-pointer" *ngIf="item.isActive==true" (click)="goToServiceGroupDetails(item.groupId)">
                <h3 class="font-weight-bold text-primary h6 mb-0">{{item.groupName}}</h3>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainGroups?.length > 10">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelServiceGroupList($event)" class="d-flex justify-content-center"></pagination-controls>
                <div class="page_numbers">{{indexPage}}/{{paginationCount(mainGroups?.length)}}</div>
            </div>
        </div>
    </div>

</div>